import { FormNumericInput } from 'components/form-fields';
import { useValidation } from 'hooks/useValidation';
import PropTypes from 'prop-types';
import React, { Fragment, useEffect } from 'react';
import classNames from 'classnames';

export function OcrIntegerLayout(
    {
        loading = false,
        disabled = false,
        readonly = false,
        layout,
        onChange
    }
) {
    const [_, errors, validate] = useValidation();

    useEffect(() => {
        validateLayout();
    }, [layout.answer]);

    function validateLayout() {
        const required = layout.requiredAnswerCount > 0;
        const rules = [{ fieldName: 'answer', required: required }];
        validate(rules, layout);
    }

    function onValueChange(value) {
        const clonedLayout = { ...layout };

        clonedLayout.answer = value;

        onChange(clonedLayout);
    }

    return (
        <Fragment>
            <div className={classNames("form-field", { "hide-in-print": !readonly, "hidden": readonly })}>
                <FormNumericInput
                    loading={loading}
                    disabled={disabled}
                    onValueChange={onValueChange}
                    selectedValue={layout.answer ? layout.answer : ''}
                    headingText={layout.secondaryLayoutTitle}
                    dangerHelperText={errors.answer}
                    allowDecimal={false}
                />
            </div>
            <p className={classNames({ "show-in-print": !readonly, "visible": readonly, "bp6-skeleton": loading  })}>{layout.answer}</p>
        </Fragment>
    );
}

OcrIntegerLayout.propTypes = {
    loading: PropTypes.bool,
    layout: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool
};
